import { useCallback, useState } from 'react'
import { Input, Label, ThemeableStack } from 'tamagui'

interface KInputProps extends React.ComponentProps<typeof Input> { }

export function KInput({ value, placeholder, onFocus, onBlur, id, ...props }: KInputProps) {
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = useCallback((e: any) => {
    setIsFocused(true)
    if (onFocus) onFocus(e)
  }, [onFocus])

  const handleBlur = useCallback((e: any) => {
    setIsFocused(false)
    if (onBlur) onBlur(e)
  }, [onBlur])

  const isFloating = isFocused || !!value

  return (
    <ThemeableStack f={1} jc="center" pos="relative">
      <Label
        htmlFor={id}
        pos="absolute"
        pe="none"
        theme="alt1"
        animation="200ms"
        zIndex={1}
        color="$gray9"
        pl="$3"
        t={isFloating ? '$0.75' : undefined}
        size={isFloating ? '$1' : '$true'}
      >
        {placeholder}
      </Label>
      <Input
        id={id}
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete="off"
        color="$color12"
        borderColor="$gray8"
        h={48}
        pt={isFloating ? 15 : 0}
        textAlignVertical="center"
        placeholderTextColor="transparent"
        {...props}
      />
    </ThemeableStack>
  )
}